"use strict";

angular.module("internal.exams").controller("InternalExamFormInfo", [
    "$scope",
    "$stateParams",
    "EXForms",
    "$state",
    "$window",
    function ($scope, $stateParams, ExamForm, $state, $window) {
        var examinfo = {};

        $scope.masterForm = $stateParams.ExamFormInfo;
        $scope.examinfo = $stateParams.ExamFormInfo;
        $scope.formID = $stateParams.id;
        $scope.deleting = false;
        $scope.loading = true;
        $scope.formInfo = {};
        $scope.canDelete = false;
        $scope.saving = false;
        $scope.parentInfoLoaded = false;
        $scope.parentpromises = [];
        $scope.examFormID = "";
        $scope.saveMessage = $stateParams.saveMessage;

        $scope.setmasterForm = function (examinfo) {
            $scope.masterForm = examinfo;
            $scope.examinfo = angular.copy($scope.masterForm);
        };

        $scope.resetExamFormInfo = function () {
            if ($scope.masterForm == null) {
                $scope.masterForm = {};
            }
            $scope.examinfo = angular.copy($scope.masterForm);
        };

        $scope.getFormInfo = function () {
            $scope.loading = true;

            ExamForm.getform($stateParams.id).then(function (formInfo) {
                var packetsLinks = [];
                examinfo = formInfo;
                $scope.examinfo = formInfo;
                $scope.examFormID = formInfo.fb_form_id;
                ExamForm.getPacketListById($scope.examinfo.id).then(function (
                    packetList
                ) {
                    packetList.records.forEach(function (l) {
                        var packetlink = {
                            state: "internal.exams.administrative.packet",
                            name: l.name + " ",
                            id: l.id
                        };
                        packetsLinks.push(packetlink);
                    });
                    var packetlink = {
                        state: "internal.exams.administrative.packet",
                        name: "",
                        image: "add",
                        id: ""
                    };
                    packetsLinks.push(packetlink);
                    $scope.examinfo.packets = packetsLinks;
                });

                $scope.loading = false;
            });
        };

        $scope.goToPacket = function (link) {
            if (link != null) {
                $state.go(link.state, { id: link.id });
            }
        };

        $scope.setMasterExamForm = function (formInfo) {
            $scope.masterForm = formInfo;
            $scope.examinfo = angular.copy($scope.masterForm);
        };

        $scope.save = function () {
            $scope.saving = true;
            examinfo = $scope.examinfo;

            ExamForm.save(examinfo).then(function (formreturn) {
                $scope.saving = false;
                $scope.setmasterForm(formreturn);
                if (formreturn != null) {
                    if ($stateParams.id == null) {
                        $state.go("internal.exams.administrative.form.details", { id: formreturn.id, saveMessage: "Record created successfully" });
                    }
                    else {
                        $scope.saveMessage = "Record updated successfully";
                    }
                } else {
                    $scope.saveMessage = "Error: Save failed";
                }
                $window.scrollTo(0, 0);
            });
        };

        $scope.delete = function () {
            if ($scope.examinfo.packets.length > 1) {
                $scope.saveMessage = "You must remove this form from all packets before deleting.";
                $window.scrollTo(0, 0);
            }
            else {
                $scope.deleting = true;
                if (window.confirm("Are you sure you want to delete this form?")) {
                    ExamForm.delete($scope.formID).then(function () {
                        $scope.deleting = false;
                        $state.go("internal.exams.administrative.forms");
                    });
                } else {
                    $scope.deleting = false;
                }
            }
        };

        $scope.copy = function () {
            $scope.copying = true;
            var ExamFormIDInfo = "";
            ExamFormIDInfo = $scope.formID;
            ExamForm.copy(ExamFormIDInfo).then(function (returnID) {
                if (returnID) {
                    if (!returnID.includes("Error")) {
                        $state.go("internal.exams.administrative.form.details", {
                            id: returnID
                        });
                    }
                    else {
                        $scope.saveMessage = returnID;
                    }
                }
                else {
                    $scope.saveMessage = "Error: Copying the form.  Please contact support.";
                }
                $scope.copying = false;
                $window.scrollTo(0, 0);
            });
        };

        $scope.clear = function () {
            $state.go("internal.exams.administrative.form.details", {
                id: ""
            });
        };

        if ($stateParams.id != null) {
            $scope.getFormInfo();
        } else {
            ExamForm.name = "";
            ExamForm.active = 1;
            ExamForm.number_of_missed_critical_questions_to_cause_fail = 0;
            ExamForm.require_result = 1;
            ExamForm.display_total_scores = 1;
            ExamForm.number_of_points_to_pass = 0;
            ExamForm.comments = "";
            ExamForm.active_status = true;

            $scope.setMasterExamForm(ExamForm);
            $scope.loading = false;
        }
    }
]); 
